import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { Icon } from '@calendly/ui/components/icon';
import { AddMiniIcon } from '@calendly/ui/components/icons';
import { Group, Item } from '@calendly/ui/components/menu';
import { OptionUI } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useMemo, forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Layout } from 'components/layout';
import { useTrackAvailabilityInteraction } from 'hooks/analytics_events/use_track_availability_interaction';
import { SCHEDULES_PATH } from '../../../constants';
import { StyledDropdownMenu } from '../styles';
import { CreateSchedulePopup } from './create_schedule_popup';
const controlButtonCss = "cdcrter";
const ControlButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(controlButtonCss, props.className)} />);
const getScheduleOptions = sortedSchedules => {
  const [defaultSchedule] = sortedSchedules;
  return sortedSchedules.map(schedule => {
    const isDefault = schedule.id === defaultSchedule.id;
    return {
      value: `${SCHEDULES_PATH}${isDefault ? '' : `/${schedule.id}`}`,
      name: isDefault ? `${schedule.name} ${I18n.t('publisher.event_type_editor.sections.available_hours.default_indicator')}` : schedule.name
    };
  });
};
export const ScheduleSelect = ({
  sortedSchedules,
  disabled
}) => {
  const [toggle, Dropdown, isExpanded] = useDropdown();
  const history = useHistory();
  const scheduleOptions = useMemo(() => getScheduleOptions(sortedSchedules), [sortedSchedules]);
  const isCreateSchedulePopupOpen = history.location.search.includes('new=true');
  const trackViewScheduleMenu = useTrackAvailabilityInteraction({
    action: 'view_schedule_menu'
  });
  const trackClickCreateSchedule = useTrackAvailabilityInteraction({
    action: 'click_create_schedule'
  });
  const handleClick = () => {
    if (!isExpanded) trackViewScheduleMenu();
    toggle();
  };
  const handleCreateSchedule = () => {
    if (!isCreateSchedulePopupOpen) trackClickCreateSchedule();
    history.push(`${history.location.pathname}?new=true`);
  };
  return <Layout relative>
      <ControlButton aria-labelledby="rule-select-label" disabled={disabled} onClick={handleClick}>
        {scheduleOptions.find(({
        value
      }) => value === history.location.pathname)?.name}
        <Icon size="large" name={isExpanded ? 'angle-up' : 'angle-down'} />
      </ControlButton>
      <Dropdown>
        <StyledDropdownMenu>
          <Group>
            {scheduleOptions.map(({
            value,
            name
          }) => <OptionUI key={value} value={value} selected={value === history.location.pathname} onClick={() => {
            history.push(value);
            toggle();
          }}>
                <BodyText size="medium">{name}</BodyText>
              </OptionUI>)}
          </Group>
          <Group>
            <Item onClick={handleCreateSchedule}>
              <AddMiniIcon />
              {I18n.t('publisher.availability.schedules.create_schedule')}
            </Item>
          </Group>
        </StyledDropdownMenu>
      </Dropdown>
      {isCreateSchedulePopupOpen && <CreateSchedulePopup />}
    </Layout>;
};

require("./schedule_select.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./schedule_select.js");